import { SelectMenuOption } from "../../../form/select-menu/select-menu.component";
import { ParentQuestionType } from "../event-page-models/parent-question";

export const parentEventQuestionsCardSelectMenuOptions: SelectMenuOption[] = [
  {
    icon: "fa-check-circle",
    key: "checkbox",
    text: "אישור",
    customValue: ParentQuestionType.CheckBox,
  },
  {
    icon: "fa-list",
    key: "dropdown",
    text: "רשימה ",
    customValue: ParentQuestionType.Dropdown,
  },
  {
    icon: "fa-file-text",
    key: "text",
    text: "תשובה קצרה",
    customValue: ParentQuestionType.Text,
  },
];



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form-parent-questions-card/parent-event-questions-card-select-menu-options.ts